<template>
  <div id="match-container"
    :data-frame="frame" class="finder-page">
    <div class="background-bar"></div>
    <div class="background-bar"></div>
    <div class="background-bar"></div>
    <div class="background-bar"></div>

    <thinking-loader :frame="frame" v-if="isLoading"></thinking-loader>

    <div class="content-container">
      <img src="/static/logo.svg" alt="" class="logo"  height="17" width="143">
      <h3 class="subtitle">SKIN SOLUTIONS</h3>
      <h2 class="title">
        It's a Match!
        <span class="drop-shadow">
          It's a Match!
        </span>
      </h2>
      <h3 class="title is-3">
        {{ title }}
        <span class="drop-shadow">
          {{ title }}
        </span>
      </h3>

      <!-- Circle & Bottle -->
      <div class="image-to-animate">
        <div class="circle"></div>
        <img class="bottle" :src="img" alt="">
      </div>

      <div class="content">
        <button class="start-button" @click="changePage"
          >
          Meet my Match
        </button>
        <h3 class="subtitle lower">#SerumSOS</h3>
      </div>
    </div>


  </div>
</template>

<script>
//import StarLogo from '@/assets/star.svg'
import ThinkingLoader from './ThinkingLoader'

  export default {
    name: "MatchPage",
    components: {
      //StarLogo,
      ThinkingLoader
    },
    props: {
      matchContent: {
        type: Array,
        required: true
      },
      product: {
        type: [String, Number],
        required: true
      },
      frame: {
        type: String,
        required: true
      }
    },
    mounted() {
      var self = this;

      // var maxElements = 15;
      // var duration = 1000;
      // this.toAnimate = [];
      // var container = document.getElementById('match-container');

      // var radius = container.offsetWidth < container.offsetHeight ? container.offsetWidth : container.offsetHeight;
      // self.distance = radius / 3 <= 120 ? 120 : radius / 3;

      // var createElements = (function() {
      //   var fragment = document.querySelector('[data-frame="' + self.frame + '"] .content-container');
      //   for (var i = 0; i < maxElements; i++) {
      //     var el = document.createElement('div');
      //     el.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" class="star"><path d="M12 .587l3.668 7.568L24 9.306l-6.064 5.828 1.48 8.279L12 19.446l-7.417 3.967 1.481-8.279L0 9.306l8.332-1.151z"></path></svg>`;

      //     el.classList.add('particule');
      //     self.toAnimate.push(el);
      //     fragment.appendChild(el);
      //   }
      //   container.appendChild(fragment);
      // })();

      // Fade in content
      anime.timeline().add({
        targets: '[data-frame="' + self.frame + '"]#match-container',
        opacity: [0, 1],
        easing: 'easeOutExpo',
        delay: 400,
        duration: 1500,
      })
      // Slide in Background bars
      .add({
        targets: '[data-frame="' + self.frame + '"] div.background-bar',
        top: 0,
        delay(el, i) {
          return 2000 + 300 * i;
        },
        duration: 1500,
        easing: 'easeOutCubic',
        complete() {
         self.isLoading = false;
        }
      })
      // Set Content To Foreground
      .add({
        targets: '[data-frame="' + self.frame + '"] .match-container',
        offset: "-=1000",
        duration: 1,
        begin() {
          document.querySelector('[data-frame="' + self.frame + '"] .content-container').style.zIndex = 300;
          self.animate();
        }
      })
    },
    data() {
      return {
        toAnimate: [],
        distance: 0,
        isLoading: true,
      }
    },
    computed: {

      title() {
        return this.matchContent[this.product].title;
      },
      img() {
        return this.matchContent[this.product].img;
      },
      url() {
        return this.matchContent[this.product].url;
      }
    },
    methods: {
      changePage() {

        document.location.href = this.url;
      },

      animate() {
        var self = this;
        console.log('%c✔' + this, 'color: green')
        // var animate = function(el, i) {
        //   var angle = Math.random() * Math.PI * 2;
        //   anime({
        //     targets: el,
        //     translateX: [0, Math.cos(angle) *1.2* self.distance],
        //     translateY: [0, Math.sin(angle) *1.2* self.distance],
        //     scale: [1.5, 2, 1],
        //     opacity: [0.5, 1, 0],
        //     delay: 100 + Math.random() * 700,
        //     duration: 1500,
        //     easing: 'easeOutSine',
        //   });
        // }

        // this.toAnimate.forEach(animate);

        // Make Circle Pop
        var circleAnimation = anime({
          targets: '.circle',
          width: [0, "70%"],
          paddingTop: [0, "35%"],
          paddingBottom: [0, "35%"],
          translateX: ['-50%','-50%'],
          translateY: ['-50%','-50%'],
          opacity: [0, 1],
          duration: 1500,
          elasticity: 400,
          delay: 0,
        })
        // Make Bottle Pop
        var bottleAnimation = anime({
          targets: '.bottle',
          width: [0, "90%"],
          height: [0, "auto"],
          translateX: ['-50%','-50%'],
          translateY: ['-50%','-50%'],
          opacity: [0, 1],
          duration: 1500,
          elasticity: 600,
          delay: 0,
        })
      }
    }
  }
</script>

<style lang="scss" >
  .logo{
    width: 143px;
    height: 17px;
  }

  .particule {
    position: absolute;
    top: 45%;
    left: 50%;
    width: 1em;
    height: 1em;
    margin: -.5em 0 0 -.5em;
    border-radius: 50%;
    font-size: 10px;
    opacity: 0;

    transform-origin: center center;

    svg {
      fill: $color-primary;
    }
    transform: scale(1);

    z-index: 3;
  }

  .circle {
    position: absolute;
    width: 50%;
    padding-top: 50%;
    padding-bottom: 50%;
    border-radius: 50%;

    border: 1px solid $color-primary;

    left: 50%;
    top: 50%;
    opacity: 0;

    transform: translateX(-50%) translateY(-50%);

    transform-origin: center center;

    background-color: #FFF;
    z-index: 2;
  }
  #match-container {
    width: 100%;

    overflow: hidden;
    position: relative;

    display: flex;
    flex-direction: column;

    .content-container {
      width: 100%;
      height: 100%;
      padding-top: 30px;

      flex-grow: 1;

      display: flex;
      flex-direction: column;
      align-items: center;

      z-index: 3;
      position: relative;

      .skin-solutions {
        margin: 0;
        color: white;
        font-size: 0.8em;
        font-weight: 600;
      }

      .title {
        font-family: $font-title;
        font-size: 3em;
        color:white;
        margin: 0;
        font-weight: normal;

        position: relative;

        line-height: 1.25em;



        .drop-shadow {
          position: absolute;
          text-align: center;
          left: 0px;
          top: 0px;

          width: 100%;
          font-weight: normal;

          font-family: $font-title-drop;
          color: white;
        }

        &.is-3 {
          margin: 0;
          font-size: 1.5em;
        }

      }
    }

    opacity: 0;

    .title {
      font-size: 3em;
      margin-top: 0.25em;
      margin-bottom: 0.5em;

      color: white;
    }

    .image-to-animate {
      position: relative;
      flex-grow: 1;
      width: 100%;
      max-width: 400px;



      @media all and (max-width: 376px) {
        transform:scale(.85);
      }

      @media all and (max-width: 321px) {
        transform:scale(.75);
      }

    }

    .content {
      width: 100%;

      color: white;

      div {
        margin-top: 1em;
        margin-bottom: 1em;
        font-size:1.25em;
        font-weight: 600;
      }
    }
  }

  .bottle {
    z-index: 4;
    // width: 0;
    // height: 0;
    width: 90%;
    height: auto;



    position: absolute;

    //object-fit: contain;
    //opacity: .5;


    transform-origin: center center;

    top: 50%;
    left: 50%;
  }

  .start-button {
    cursor: pointer;
    display: block;
    background-color: #fff;
    color: black;

    border: none;

    // padding: 1.5em 2em;
    width: 200px;
    height: 50px;
    line-height: 50px;

    text-transform: uppercase;

    font-family: $sans-serif;
    font-weight: bold;

    //width: fit-content;
    margin: auto;
    margin-bottom: 1.5em;
    font-size: 13px;
    text-decoration: none;
  }

  // button.button {
  //   // text-transform: uppercase;
  //   // font-weight: bold;
  //   // font-size: 13px;
  //   // // padding: 1.75em 3em;

  //   // width: 200px;
  //   // height: 50px;
  //   // line-height: 50px;

  //   // background-color: #FFF;

  //   // margin-bottom: 1.5em;

  //   border: none;

  //   // color: black;
  //   text-decoration: none;

  //   cursor: pointer;
  //   display: block;
  //   background-color: #fff;
  //   color: black;

  //   // padding: 1.5em 2em;
  //   width: 200px;
  //   height: 50px;
  //   line-height: 50px;

  //   text-transform: uppercase;

  //   font-family: $sans-serif;
  //   font-weight: bold;

  //   //width: fit-content;
  //   margin: auto;
  //   margin-bottom: 1.5em;
  //   font-size: 13px;

  //   a {
  //     color: black;
  //     text-decoration: none;
  //   }
  // }

  .background-bar {
    position: absolute;
    width: 25%;
    height: 100%;

    z-index: 200;

    &:nth-child(4n + 1) {
      top: -100%;
      left: 0;
      background-color: #91cbb7;
    }
    &:nth-child(4n + 2) {
      top: 100%;
      left: 25%;
      background-color: #2baade;
    }
    &:nth-child(4n + 3) {
      top: -100%;
      left: 50%;
      background-color: #f69783;
    }
    &:nth-child(4n) {
      top: 100%;
      left: 75%;
      background-color: #fbb161;
    }
  }
</style>